/**
 *
 * @module entry
 * @desc {SDK.Content.Watchlist} entry point.
 *
 */

import WatchlistExtensions from './watchlistExtensions';
import AddToWatchlistQuery from './addToWatchlistQuery';
import ClearWatchlistQuery from './clearWatchlistQuery';
import RemoveFromWatchlistQuery from './removeFromWatchlistQuery';
import WatchlistQuery from './watchlistQuery';

/**
 *
 * @typedef SDK.Content.Watchlist
 * @type {Object}
 *
 * @property {Function} WatchlistExtensions
 * @property {AddToWatchlistQuery} AddToWatchlistQuery
 * @property {ClearWatchlistQuery} ClearWatchlistQuery
 * @property {RemoveFromWatchlistQuery} RemoveFromWatchlistQuery
 * @property {WatchlistQuery} WatchlistQuery
 *
 */

/**
 *
 * @type {SDK.Content.Watchlist}
 *
 */
export default {

    WatchlistExtensions,
    AddToWatchlistQuery,
    ClearWatchlistQuery,
    RemoveFromWatchlistQuery,
    WatchlistQuery

};



// WEBPACK FOOTER //
// ./src/content/watchlist/entry.js